var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"sentiment mr-3",attrs:{"dark":"","color":"tertiary","disabled":"","mb-0":""}},[_vm._v(_vm._s(_vm.sentimentLabel))])
}
var staticRenderFns = []

export { render, staticRenderFns }